import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject44() {
  var data = _taggedTemplateLiteral(["\n    max-width: none;\n    padding: 0 24px;\n  "]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteral(["\n    max-width: 792px;\n    padding: 0 125px;\n  "]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  ", "\n  ", "\n"]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n      font-size: 18px;\n    "]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n      font-size: 14px;\n      margin-bottom: 3px;\n    "]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n      display: none;\n    "]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n      width: 46px;\n    "]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n      margin-left: 0;\n    "]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n      margin-left: 17px;\n    "]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n    max-width: none;\n    margin: 21px 24px 0;\n    padding: 20px 25px 19px 29px;\n  "]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n    max-width: 542px;\n    padding: 24px;\n    margin: 24px auto 0;\n  "]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n    padding: 24px;\n    margin-top: 24px;\n  "]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 33px 38px;\n  background-color: #f5f1f2;\n  border-radius: 6px;\n  margin-top: 40px;\n  ", "\n  ", "\n  ", "\n  .contact-info {\n    margin-left: 24px;\n    ", "\n    ", "\n  }\n  img {\n    width: 56px;\n    ", "\n    ", "\n  }\n  .contact-title {\n    font-family: ", ";\n    font-size: 18px;\n    line-height: 160%;\n    color: #2c2c2c;\n    opacity: 0.8;\n    margin-bottom: 2px;\n    ", "\n  }\n  .contact-phone {\n    font-family: ", ";\n    font-size: 20px;\n    line-height: 160%;\n    color: #2c2c2c;\n    ", "\n  }\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n    top: 31px;\n    right: 20px;\n    z-index: 10;\n  "]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n    & span {\n      display: block;\n      background-color: #2C2C2C;\n      height: 2px;\n      width: 16px;\n      &:first-child {\n        transform: rotate(45deg);\n      }\n      &:last-child {\n        transform: rotate(-45deg) translate(1px, -1px);\n      }\n    }\n  "]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  position: absolute;\n  top: 40px;\n  right: 40px;\n  ", "\n  ", "\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n    padding: 20px 0;\n  "]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n    padding: 23px 0 20px;\n    margin-top: auto;\n  "]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n    padding: 20px 40px;\n  "]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  padding: 40px 80px;\n  box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.05);\n  flex-shrink: 0;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n    position: static;\n    padding: 20px 24px 0;\n    width: 100%;\n    max-width: none;\n    margin: 0;\n    font-size: 20px;\n    line-height: 110%;\n  "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    line-height: 16px;\n    right: 24px;\n    top: 16px;\n    padding: 0;\n  "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n    position: static;\n    padding: 110px 125px 20px;\n    width: 100%;\n    max-width: 792px;\n    margin: 0 auto;\n    font-size: 24px;\n  "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n    font-size: 18px;\n    line-height: 110%;\n    position: absolute;\n    right: 25px;\n    top: 28px;\n  "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n    margin: 0;\n    padding: 0 40px;\n  "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin: 0 0 10px;\n  font-size: 30px;\n  font-family: ", ";\n  padding: 0 80px;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    font-size: 12px;\n    line-height: 16px;\n    width: 24px;\n    height: 24px;\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    font-size: 10px;\n    line-height: 16px;\n    width: 18px;\n    height: 18px;\n  "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    width: 30px;\n    height: 30px;\n    font-size: 14px;\n    line-height: 16px;\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    width: 24px;\n    height: 24px;\n    font-size: 12px;\n    line-height: 24px;\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    width: 30px;\n    height: 30px;\n    line-height: 32px;\n    margin-left: 10px;\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  line-height: 38px;\n  background-color: ", ";\n  border-radius: 50%;\n  color: ", ";\n  margin-left: 20px;\n  text-align: center;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    padding: 0 24px 30px;\n    max-width: none;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    padding: 0 125px 30px;\n    max-width: 792px;\n    margin: 0 auto;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    padding: 0 40px;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 80px;\n  margin-bottom: auto;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  ", "\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    background-color: #f6f7f8;\n    z-index: 2;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    padding-top: 0;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n    background-color: transparent;\n    z-index: 1;\n    overflow-y: auto;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding-top: 30px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: #f6f7f8;\n  min-height: 100vh;\n  padding-top: 60px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Wrapper = styled.div(_templateObject(), media.xxLargeScreen(_templateObject2()), media.xLargeScreen(_templateObject3()), function (props) {
  return props.mobileCartOpened && media.xLargeScreen(_templateObject4());
});
export var Content = styled.div(_templateObject5(), media.xLargeScreen(_templateObject6()), function (props) {
  return props.mobileCartOpened && media.xLargeScreen(_templateObject7());
});
export var CartSummaryProductList = styled.div(_templateObject8(), media.xxLargeScreen(_templateObject9()), media.xLargeScreen(_templateObject10()), media.mediumScreen(_templateObject11()));
export var Count = styled.span(_templateObject12(), function (props) {
  return props.theme.colors.baseFont;
}, function (props) {
  return props.theme.colors.white;
}, media.xxxLargeScreen(_templateObject13()), media.xLargeScreen(_templateObject14()), function (props) {
  return props.mobileCartOpened && media.xLargeScreen(_templateObject15());
}, media.mediumScreen(_templateObject16()), function (props) {
  return props.mobileCartOpened && media.mediumScreen(_templateObject17());
});
export var Title = styled.div(_templateObject18(), function (props) {
  return props.theme.typography.thinFontFamily;
}, media.xxLargeScreen(_templateObject19()), media.xLargeScreen(_templateObject20()), function (props) {
  return props.mobileCartOpened && media.xLargeScreen(_templateObject21());
}, media.mediumScreen(_templateObject22()), function (props) {
  return props.mobileCartOpened && media.mediumScreen(_templateObject23());
});
export var ArrowUp = styled.div(_templateObject24());
export var CartSummaryInfo = styled.div(_templateObject25(), media.xxLargeScreen(_templateObject26()), media.xLargeScreen(_templateObject27()), media.mediumScreen(_templateObject28()));
export var CloseBtn = styled.button(_templateObject29(), function (props) {
  return props.mobileCartOpened && media.xLargeScreen(_templateObject30());
}, media.mediumScreen(_templateObject31()));
export var Contact = styled.div(_templateObject32(), media.xxLargeScreen(_templateObject33()), media.xLargeScreen(_templateObject34()), media.mediumScreen(_templateObject35()), media.xxLargeScreen(_templateObject36()), media.smallScreen(_templateObject37()), media.xxLargeScreen(_templateObject38()), media.smallScreen(_templateObject39()), function (props) {
  return props.theme.typography.extraFontFamily;
}, media.xxLargeScreen(_templateObject40()), function (props) {
  return props.theme.typography.baseFontFamily;
}, media.xxLargeScreen(_templateObject41()));
export var CartSummaryInner = styled.div(_templateObject42(), media.xLargeScreen(_templateObject43()), media.mediumScreen(_templateObject44()));